
import React from 'react';
import { SimulationConfig, MelodyName } from './types';
import { SectionLabel } from './SectionLabel';

interface MelodyLibrarySectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const MelodyLibrarySection: React.FC<MelodyLibrarySectionProps> = ({ config, setConfig }) => {
  const melodies: MelodyName[] = [
    'Original Masterpiece',
    'Pentatonic', 'Megalovania', 'Mario', 'Imperial March', 'Tetris', 'Rickroll', 'Pokemon', 'Zelda', 'Nokia', 
    'Fur Elise', 'Canon in D', 'Mortal Kombat', 'Axel F', 'Pirates', 'Star Wars', 'Harry Potter', 'Minecraft', 
    'SpongeBob', 'Under the Sea', 'Circle of Life', 'Smooth Criminal', 'Billie Jean', 'Seven Nation Army', 
    'We Will Rock You', 'Sandstorm', 'Mission Impossible', 'James Bond', 'Nostalgia', 'Gravity Falls', 'Kerosene',
    'Interstellar', 'Inception', 'Stranger Things', 'Cyberpunk', 'Get Lucky', 'Blinding Lights', 'Take On Me',
    'Final Fantasy', 'Doom', 'Pac-Man', 'Sonic', 'Skyrim', 'Bad Apple', 'Rush E', 'Giorno',
    'One Summers Day', 'Merry-Go-Round', 'Unravel', 'Cruel Angel', 'Tokyo Ghoul',
    'Custom (Uploaded)'
  ];

  const removeCustomMelody = (name: string) => {
    setConfig(prev => ({
        ...prev,
        customMelodies: prev.customMelodies.filter(m => m.name !== name),
        selectedMelody: prev.selectedMelody === name ? 'Pentatonic' : prev.selectedMelody
    }));
  };

  return (
    <div className="flex flex-col gap-3 p-4 rounded-3xl border bg-purple-500/5 border-purple-500/20">
      <SectionLabel icon="fa-guitar" darkMode={config.darkMode}>Melody Library</SectionLabel>
      <select 
        value={config.selectedMelody} 
        onChange={e => setConfig(p => ({ ...p, selectedMelody: e.target.value as MelodyName }))} 
        className={`w-full px-3 py-2 border rounded-xl text-[10px] font-black mb-2 ${config.darkMode ? 'bg-neutral-800 border-neutral-700' : 'bg-white border-neutral-200'}`}
      >
        <optgroup label="Core Melodies">
            {melodies.map(m => <option key={m} value={m}>{m}</option>)}
        </optgroup>
        {config.customMelodies.length > 0 && (
            <optgroup label="User Created">
                {config.customMelodies.map(m => <option key={m.id} value={m.name}>{m.name}</option>)}
            </optgroup>
        )}
      </select>
      
      {config.customMelodies.length > 0 && (
          <div className="flex flex-col gap-2 p-2 rounded-xl bg-purple-500/10 border border-purple-500/20">
              <span className="text-[8px] font-black uppercase text-purple-400 opacity-60">Manage User Melodies</span>
              <div className="flex flex-wrap gap-1">
                  {config.customMelodies.map(m => (
                      <div key={m.id} className="flex items-center gap-1 bg-purple-600 text-white px-2 py-0.5 rounded-lg text-[8px] font-black uppercase">
                          {m.name}
                          <button onClick={() => removeCustomMelody(m.name)} className="opacity-60 hover:opacity-100"><i className="fa-solid fa-times"></i></button>
                      </div>
                  ))}
              </div>
          </div>
      )}
    </div>
  );
};